import { render } from "./RegLayout.vue?vue&type=template&id=22c31bf3&scoped=true"
import script from "./RegLayout.vue?vue&type=script&lang=js"
export * from "./RegLayout.vue?vue&type=script&lang=js"

import "./RegLayout.vue?vue&type=style&index=0&id=22c31bf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c31bf3"]])

export default __exports__